import SectionLabel from "@/components/base/SectionLabel";
import { nameMeaningData } from "@/mocks/aboutData";

export default function NameMeaningSection() {
  return (
    <section id="name-meaning" className="py-16 md:py-24 bg-background-100">
      <div className="max-w-[1200px] mx-auto px-4 md:px-8">
        <div className="reveal max-w-3xl mx-auto mb-10 md:mb-14 text-center">
          <SectionLabel label={nameMeaningData.label} className="mb-3" />
          <h2 className="font-heading text-xl md:text-2xl lg:text-3xl font-bold text-foreground-900 mb-5 md:mb-6">
            {nameMeaningData.heading}
          </h2>
          <div className="space-y-3 md:space-y-4 text-sm md:text-base text-foreground-700 leading-relaxed text-left">
            {nameMeaningData.paragraphs.map((p, i) => (
              <p key={i}>{p}</p>
            ))}
          </div>
        </div>

        {/* Connected horizontal flow */}
        <div className="reveal max-w-3xl mx-auto">
          <div className="flex flex-wrap md:flex-nowrap items-center justify-center gap-2 md:gap-1">
            {nameMeaningData.keywords.map((keyword, idx) => (
              <div key={idx} className="flex items-center gap-2 md:gap-1">
                <div className="flex items-center gap-2 px-3 md:px-4 py-2 md:py-2.5 bg-background-50 border border-background-200/70 rounded-full">
                  <div className="w-6 h-6 rounded-full bg-accent-100 flex items-center justify-center flex-shrink-0">
                    <span className="text-[10px] md:text-xs font-bold text-accent-600">
                      {idx + 1}
                    </span>
                  </div>
                  <span className="text-sm md:text-base font-medium text-foreground-800 whitespace-nowrap">
                    {keyword}
                  </span>
                </div>

                {idx < nameMeaningData.keywords.length - 1 && (
                  <div className="flex items-center justify-center w-6 h-6 flex-shrink-0">
                    <i className="ri-arrow-right-line text-accent-300 text-sm" />
                  </div>
                )}
              </div>
            ))}
          </div>

          <p className="text-xs text-foreground-500 text-center mt-5 md:mt-6">
            試行錯誤を繰り返しながら、お客様とともに成長するプロセス
          </p>
        </div>
      </div>
    </section>
  );
}